import {
  DialogContent,
  Dialog as MuiDialog,
  DialogTitle,
  IconButton,
  Stack,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { PropsWithChildren } from 'react';

export default function Dialog({
  open,
  onClose,
  title,
  closeLabel,
  children,
}: Readonly<
  PropsWithChildren<{
    open: boolean;
    onClose: () => void;
    title: string;
    closeLabel: string;
  }>
>) {
  return (
    <MuiDialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            borderRadius: '4px',
            maxWidth: '480px',
            width: '100%',
            margin: { xs: 1.5, sm: 3 },
          },
        },
      }}
    >
      <Stack direction='row' justifyContent='space-between' alignItems='center'>
        <DialogTitle
          component='h3'
          variant='h4'
          sx={{ paddingX: 2, flexGrow: 1, paddingY: 0 }}
        >
          {title}
        </DialogTitle>
        <IconButton aria-label={closeLabel} onClick={onClose} size='large'>
          <CloseIcon role='presentation' />
        </IconButton>
      </Stack>
      <DialogContent dividers sx={{ padding: 0 }}>
        {children}
      </DialogContent>
    </MuiDialog>
  );
}
